import { CostTreeResponse, EnvironmentFilter, Hierarchy, PeriodsResponse } from "@rossum/upcloud-costs-shared";

import { getJson } from "./http-client";

export function fetchPeriods(): Promise<PeriodsResponse> {
    return getJson<PeriodsResponse>("/api/periods");
}

export function fetchCostTree(query: {
    from: string;
    to: string;
    hierarchy: Hierarchy;
    environment: readonly EnvironmentFilter[];
}): Promise<CostTreeResponse> {
    return getJson<CostTreeResponse>("/api/cost-tree", {
        from: query.from,
        to: query.to,
        hierarchy: query.hierarchy,
        environment: query.environment.length === 0 ? undefined : query.environment,
    });
}
